import { Component, Prop } from 'vue-property-decorator';

import TombolaBaseComponent from '@/components/base/base.component';
import { ConfigurationKey, IConfigurationService } from '@/app-modules/config';
import { IDefaultIFrameMethods, ParentFrame } from '@/app-modules/iframes';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IFrameGameLoadedEventName } from '@/components/iframe-game/_domain/models';

@Component({
  name: 'IFrameGameComponent'
})
export default class IFrameGame extends TombolaBaseComponent {
  @Prop() public modalGuid: string;
  @Prop() public gameName: string;
  @Prop() public id: number;
  @Prop() public clubName: string;
  private parentFrame: ParentFrame;
  private isLoaded: boolean = false;

  private async mounted(): Promise<void> {
    const defaultMethods = this.$container.get(SERVICE_IDENTIFIERS.IDefaultMethodsService) as IDefaultIFrameMethods;
    const frameId = `game-frame-${this.getGameName()}-${this.clubName}`;
    this.parentFrame = new ParentFrame(frameId, defaultMethods.getMethods(), {
      url: this.getIFrameGameUrl(),
      frameId: this.modalGuid,
      clubId: this.id
    });

    await this.parentFrame.connectToChild(this.$refs.iframeGameContainer as HTMLDivElement);

    this.parentFrame.connection.iframe.setAttribute('style', 'width:100%; height:100%; padding: 0; margin: 0; border: none; display: block;');
    this.parentFrame.connection.iframe.classList.add('game-iframe');

    this.$eventbus.$on(IFrameGameLoadedEventName, this.onLoaded);
  }

  private beforeDestroy(): void {
    if (this.parentFrame) {
      this.parentFrame.destroy();
      this.parentFrame = null;
    }

    this.$eventbus.$off(IFrameGameLoadedEventName, this.onLoaded);
  }

  private get configurationService(): IConfigurationService {
    return this.$container.get(SERVICE_IDENTIFIERS.IConfigurationService);
  }

  private getIFrameGameUrl(): string {
    const baseUrl = this.configurationService.getConfigurationItem(ConfigurationKey.IFRAME_GAME_URL);
    return baseUrl.format({ gamename: this.getGameName() });
  }

  private getGameName(): string {
    return this.gameName.replace(/\s/g, '').toLowerCase();
  }

  private onLoaded(): void {
    this.isLoaded = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/iframe-game/iframe-game.component.ts